import React, { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { TypePage } from '../enums/TypePage';
import { TariffPlan } from '../enums/TariffPlan';

interface RequireAuthProps {
    children: ReactNode;
    companyTariffPlan: TariffPlan;
    typePage: TypePage;
}

const RequireCompanyTariff: React.FC<RequireAuthProps> = ({ children, companyTariffPlan, typePage }) => {
    if(typePage == TypePage.Test){
        if(companyTariffPlan != TariffPlan.Basic && companyTariffPlan != TariffPlan.Annual){
            return  <>{children}</>;
        }

        return <Navigate to="/" />
    }
    else{
        return <Navigate to="/" />
    }
};

export default RequireCompanyTariff;
